export const surveyInitialState = {
  propertyName: "",
  address: "",
  emirate: "",
  city: "",
  territory: "",
  latitude: "",
  longitude: "",
  accountHolderFirstName: "",
  accountHolderLastName: "",
  accountHolderMobileNumber: "",
  emirateNumber: "",
  accountHolderEmailAddress: "",
  surveyContactPersonFirstName: "",
  surveyContactPersonLastName: "",
  surveyContactPersonMobileNumber: "",
  emergencyContact1FirstName: "",
  emergencyContact1MobileNumber: "",
};
